<template>
  <ProgressCircular v-if="loading" />
  <v-expansion-panels v-else :disabled="disabled">
    <v-expansion-panel>
      <v-expansion-panel-header> Анкеты ({{ getProfileCount }})</v-expansion-panel-header>
      <v-expansion-panel-content
        v-for="profile in profilesList"
        :key="profile.id + profile.profileType"
      >
        <router-link :to="getProfileLink(profile)">{{
          getProfileName(profile)
        }}</router-link>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>
        Полученный общий доступ ({{ getSharedAccessCount }})
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="(el, idx) in getSharedAccessTitle"
            :key="idx + el.title"
          >
            <template v-if="getSharedContentLength(el)">
              <v-expansion-panel-header
                >{{ el.title }}({{ getSharedContentLength(el) }})</v-expansion-panel-header
              >
              <v-expansion-panel-content
                ><v-list>
                  <v-list-item v-for="item in el.content" :key="item.id">
                    <router-link :to="getLinkEntity(item)">{{
                      getContentTitle(item)
                    }}</router-link>
                  </v-list-item>
                </v-list></v-expansion-panel-content
              >
            </template>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel>
      <v-expansion-panel-header>
        Мои резервации ({{ getReservationsCount }})
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header
              >Резервации событий ({{ getTicketReservations }})</v-expansion-panel-header
            >
            <v-expansion-panel-content v-if="getTicketReservations > 0">
              <v-list>
                <v-list-item
                  v-for="(ticketReservation, idx) in getKeysTicketReservations"
                  :key="idx"
                >
                  <span
                    >{{ ticketReservation }}:
                    <router-link
                      :to="{
                        name: 'page-orders-event',
                        query: {
                          id: ticketReservations.list.find(
                            ticket => ticket.displayName === ticketReservation
                          ).id
                        }
                      }"
                      >{{ preparedTicketReservations[ticketReservation] }}</router-link
                    ></span
                  >
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              >Резервации отелей ({{
                getHotelReservationsCount
              }})</v-expansion-panel-header
            >
            <v-expansion-panel-content v-if="getHotelReservationsCount > 0">
              <v-list>
                <v-list-item
                  v-for="(hotelReservation, idx) in getKeysHotelReservations"
                  :key="idx"
                >
                  <span
                    >{{ hotelReservation }}:
                    <router-link
                      :to="{
                        name: 'page-orders-booking',
                        query: {
                          id: findIdForLink(hotelReservation)
                        }
                      }"
                      >{{ preparedHotelReservations[hotelReservation] }}</router-link
                    ></span
                  >
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import entityList from '@/configs/entityList'
import { getLinkEntity } from '@/utils/getLinkEntity'

import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'RelationsAccount',
  props: {
    profiles: {
      type: Object,
      default: () => null
    },
    sharedAccess: {
      type: Object,
      default: () => null
    },
    reservations: {
      type: Object,
      default: () => null
    },
    ticketReservations: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProgressCircular
  },
  computed: {
    profilesList () {
      if (!this.profiles) return 0
      const { legalDetails, personalDetails } = this.profiles
      if (!legalDetails?.length && !personalDetails?.length) return 0
      return legalDetails
        ?.map(profile => ({ ...profile, profileType: 'LEGAL' }))
        .concat(
          personalDetails?.map(profile => ({ ...profile, profileType: 'PERSONAL' }))
        )
    },
    getProfileCount () {
      return this.profilesList?.length || 0
    },
    getSharedAccessCount () {
      if (!this.sharedAccess) return 0
      return Object.values(this.sharedAccess).reduce((acc, el) => {
        if (Array.isArray(el)) {
          acc = acc + el.length
        }
        return acc
      }, 0)
    },
    getSharedAccessTitle () {
      if (!this.sharedAccess) return null
      return entityList.map(el => ({
        ...el,
        content: this.sharedAccess[el.value]
      }))
    },
    preparedHotelReservations () {
      const hotels = this.reservations?.list?.map(
        reservation => reservation?.roomType?.hotel?.title
      )
      return (
        hotels
          ?.map(hotel => ({ count: 1, name: hotel }))
          .reduce((acc, hotel) => {
            acc[hotel.name] = (acc[hotel.name] || 0) + hotel.count
            return acc
          }, {}) || null
      )
    },
    getKeysHotelReservations () {
      return Object.keys(this.preparedHotelReservations)
    },
    getHotelReservationsCount () {
      if (this.preparedHotelReservations) {
        return Object.keys(this.preparedHotelReservations)?.length || 0
      }
      return 0
    },
    getTicketReservations () {
      return this.ticketReservations?.totalCount || 0
    },
    getReservationsCount () {
      return this.getHotelReservationsCount + this.getTicketReservations
    },
    preparedTicketReservations () {
      const { list } = this.ticketReservations
      if (!list) return null
      return (
        list
          ?.map(ticket => ({ count: 1, name: ticket.displayName }))
          ?.reduce((acc, ticket) => {
            acc[ticket.name] = (acc[ticket.name] || 0) + ticket.count
            return acc
          }, {}) || null
      )
    },
    getKeysTicketReservations () {
      return Object.keys(this.preparedTicketReservations)
    }
  },
  methods: {
    getContentTitle (el) {
      if (el?.title) return el.title
      if (el?.organizationName) return el.organizationName
      if (el?.name) return el.name
      return ''
    },
    getProfileLink ({ profileType, id }) {
      if (!id || !profileType) return '#'
      if (profileType === 'LEGAL') {
        return {
          name: 'page-legal-detail',
          params: { id }
        }
      }
      if (profileType === 'PERSONAL') {
        return {
          name: 'page-personal-detail',
          params: { id }
        }
      }
      return '#'
    },
    getProfileName (profile) {
      return profile?.title || profile?.name || ''
    },
    getLinkEntity,
    findIdForLink (hotelReservation) {
      return (
        this.reservations?.list?.find(
          hotel => hotel.roomType.hotel.title === hotelReservation
        )?.roomType?.hotel?.id || '#'
      )
    },
    getSharedContentLength (el) {
      return el?.content?.length || null
    }
  }
}
</script>

<style>
</style>
